import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.mywork');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-mywork',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.mywork/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCollabMyworkComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public summary: any = {
        tasks: [], meetings: [], notifications: [], today_events: [],
        task_count: 0, meeting_count: 0, notification_count: 0,
    };
    public memberMap: any = {};
    public me: string = '';
    public loaded: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const r = await wiz.call("summary", {});
        if (r.code === 200) {
            this.summary = r.data.summary;
            this.me = r.data.me;
            for (const m of r.data.members || []) this.memberMap[m.id] = m;
        }
        this.loaded = true;
        await this.service.render();
    }

    public memberName(uid: string) {
        return this.memberMap[uid]?.name || this.memberMap[uid]?.email || uid;
    }

    public taskStatusBadge(s: string) {
        const map: any = {
            todo: { label: '할 일', cls: 'bg-zinc-100 text-zinc-600' },
            in_progress: { label: '진행중', cls: 'bg-blue-50 text-blue-600' },
            review: { label: '리뷰', cls: 'bg-amber-50 text-amber-600' },
            done: { label: '완료', cls: 'bg-emerald-50 text-emerald-600' },
            blocked: { label: '차단', cls: 'bg-rose-50 text-rose-600' },
        };
        return map[s] || { label: s, cls: 'bg-zinc-100 text-zinc-500' };
    }

    public priorityCls(p: string) {
        const map: any = {
            urgent: 'text-rose-600', high: 'text-orange-500',
            medium: 'text-zinc-500', low: 'text-zinc-400',
        };
        return map[p] || 'text-zinc-500';
    }

    public isOverdue(due: string) {
        if (!due) return false;
        return due < new Date().toISOString().slice(0, 10);
    }

    public goTask(t: any) {
        this.service.href(`/admin/collab/task/${t.workspace_id || ''}/${t.id}`);
    }
    public goMeeting(m: any) {
        this.service.href(`/admin/collab/meeting/${m.id}`);
    }
    public goNotif(n: any) {
        if (n.link) this.service.href(n.link);
    }
}

export default PortalLpsysadminCollabMyworkComponent;